import React, { useRef, useEffect, useState } from "react";

import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
    Menu,
    MenuItem,
    Divider
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import { useService } from "contexts/ServiceContextProvider";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MenuIcon from '@mui/icons-material/Menu';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';
import ArchiveIcon from '@mui/icons-material/Archive';
import AttachmentsModal from './AttachmentsModal';
import DeleteLabelModal from './DeleteLabel'
import 'react-medium-image-zoom/dist/styles.css';
import "../../css/main.css";
import "../../css/components/Modals/ViewTask.css";

import { getTextColor } from '../../utils/ColorUtils.jsx'

import CommonAvatarGroup from '../Core/CommonAvatarGroup'

import { useSnackbar } from 'contexts/SnackbarContextProvider';

import { checkForWorkspaceStorageLimitError } from "utils/WorkspaceStorageLimit";

import GroupAddIcon from '@mui/icons-material/GroupAdd';
import {
    ConvertToMyTimeZone,
    formatDateToStringHHMM
} from "components/Custom/TimezoneConvertion.jsx";
import TaskDatesDialog from "components/Core/TaskDatesDialog.jsx";
import ArchiveTaskModal from "./ArchiveTask";
import TextEditor from "../Custom/TextEditor";
import ActivityLog from "../Custom/ActivityLogComponent";
import ChecklistComponent from "../Custom/ChecklistComponent";
import { useTranslation } from "react-i18next";
import CoverPickerModal from "../Modals/CoverPickerModal";
import DownloadWarningModal from "../Modals/DownloadWarning";
import LayersClearIcon from '@mui/icons-material/LayersClear';
import EncryptFileModal from "../Modals/EncryptFiles";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import LabelsComponent from "./LabelsComponent";


import Comments from "../Core/TaskComments";
import ScrollAwareTooltip from "components/Custom/ScrollAwareTooltip";

/* eslint-disable react-hooks/exhaustive-deps */
export default function ViewTaskModal({
    openViewTaskModal,
    handleSaveTask,
    handleViewTaskModalClose,
    myBoard,
    List,
    task_id,
    setMyBoard,
    updateToggleLabel,
    myUserTimezone,
    handleMarkAsDone,
    handleMarkAsDoing,
    handleArchiveTask,
    avoidMisfire,
    setContextTaskMenuPosition,
    autoFocusLabel,
    setAutoFocusLabel,
    openCover,
    setCoverModalOpen,
    workspace_id,
    getCurrentlyLoggedUser,
    workspaceWorkers,
    getColorForTask,
    formatDate
}) {

    const { t } = useTranslation();

    const { showSnackbar } = useSnackbar();

    const [editingTaskTitle, setEditingTaskTitle] = useState(false);
    const [editTaskNewTitle, setEditTaskNewTitle] = useState("");
    const [Task, setTask] = useState("");
    const {
        GetTaskInformation,
        UpdateTaskDates,
        DeleteChecklist,
        UpdateTask,
        SaveTaskLabels,
        AddLabelToBoard,
        DeleteLabel,
        updateTaskMembers,
        getMoreChecklistItems,
        UpdateTaskDescription,
        CreateChecklist,
        CreateChecklistItem,
        GetChecklists,
        UpdateChecklistItem,
        DeleteChecklistItem,
        UpdateChecklistTitle,
        UpdateChecklistOrder,
        UpdateLabel,
        UpdateTaskCover,
        HandleUploadAttachment,
        DeleteTaskAttachment,
        ToggleHiddenStatusOfChecklists,
        ToggleHiddenStatusOfChecklistItems,
        ConvertToTask,
        getWorkspacePublicKey,
        downloadEncryptedFile,
        GetFullActivityLogs,
        getProjectWorkers
    } = useService();

    const [openLabels, setOpenLabels] = useState(false);
    const [labelTitle, setLabelTitle] = useState("");
    const [labelAdding, setLabelAdding] = useState(false);

    const [selectedTaskLabels, setSelectedTaskLabels] = useState([]);
    const [selectedTaskMembers, setSelectedTaskMembers] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");
    const [taskMembersDialogOpen, setTaskMembersDialogOpen] = useState(false);
    const [taskDatesDialogOpen, setTaskDatesDialogOpen] = useState(false);
    const [description, setDescription] = useState();
    const [openArchiveTaskModal, setOpenArchiveTaskModal] = useState(false);

    const [checklists, setChecklists] = useState([]);
    const [editChecklistTitles, setEditChecklistTitles] = useState({});
    const [newChecklistTitles, setNewChecklistTitles] = useState({});

    const [taskTitleError, setTaskTitleError] = useState([]);
    const [taskComments, setTaskComments] = useState([]);
    const [hasMoreComments, setHasMoreComments] = useState(true);

    const [labelEditing, setLabelEditing] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(false);

    const [, setPastedImage] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [openCoverImageModal, setOpenCoverImageModal] = useState(false);

    const [actionsDropdownOpen, setActionsDropdownOpen] = useState(window.innerWidth > 900);

    const [openMobileAttachmentModal, setOpenMobileAttachmentModal] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);

    const [openDownloadWarningModal, setOpenDownloadWarningModal] = useState(false);
    const [selectedFileUrl, setSelectedFileUrl] = useState("");

    const [openEncryptFileModal, setOpenEncryptFileModal] = useState(false);

    const [encryptDecision, setEncryptDecision] = useState(false);
    const [publicKeyWorkspaceKey, setPublicKeyWorkspaceKey] = useState(null);
    const fileInputRef = useRef(null);


    const [taskActivityLog, setTaskActivityLog] = useState([]);

    const [isLoadingActivityLog, setIsLoadingActivityLog] = useState(true);

    const [showAllActivity, setShowAllActivity] = useState(false);
    const toggleShowAllActivity = () => setShowAllActivity((prev) => !prev);

    const [filteredProjectWorkers, setFilteredProjectWorkers] = React.useState([]);

    const [labelToEdit, setLabelToEdit] = useState('');

    const contentRef = useRef(null);
    const [hasScroll, setHasScroll] = useState(false);

    useEffect(() => {
        if (!contentRef.current || !openViewTaskModal) return;

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { scrollHeight, clientHeight } = entry.target;
                setHasScroll(scrollHeight > clientHeight);
            }
        });

        observer.observe(contentRef.current);
        return () => observer.disconnect();
    }, [contentRef.current, openViewTaskModal]);

    const fetchAllActivityLogs = async () => {
        if (!showAllActivity) {
            setIsLoadingActivityLog(true);
            try {
                const fullLogResponse = await GetFullActivityLogs(workspace_id, myBoard.project, task_id);
                setTaskActivityLog(fullLogResponse);
            } catch (error) {
                console.error("Error fetching full activity log:", error);
            } finally {
                setIsLoadingActivityLog(false);
            }
        }
    };

    const handleFileEncryption = async (shouldEncrypt) => {
        if (shouldEncrypt) {
            const response = await getWorkspacePublicKey(workspace_id);
            setPublicKeyWorkspaceKey(response);
        }

        setOpenEncryptFileModal(false);
        setEncryptDecision(shouldEncrypt);
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    async function generateAESKey() {
        return window.crypto.subtle.generateKey(
            {
                name: "AES-GCM",
                length: 256,
            },
            true,
            ["encrypt", "decrypt"]
        );
    }

    async function encryptFileWithAES(file, aesKey) {
        const fileArrayBuffer = await file.arrayBuffer();

        const iv = window.crypto.getRandomValues(new Uint8Array(12));
        const encryptedContent = await window.crypto.subtle.encrypt(
            {
                name: "AES-GCM",
                iv: iv,
            },
            aesKey,
            fileArrayBuffer
        );

        return { encryptedContent, iv };
    }

    async function encryptAESKeyWithRSA(aesKey, publicKeyPem) {
        const publicKey = await importRSAPublicKey(publicKeyPem);

        const aesKeyRaw = await window.crypto.subtle.exportKey("raw", aesKey);
        return window.crypto.subtle.encrypt(
            {
                name: "RSA-OAEP",
            },
            publicKey,
            aesKeyRaw
        );
    }

    async function importRSAPublicKey(pemKey) {
        const keyData = pemKey.replace(/-----BEGIN PUBLIC KEY-----/, '')
            .replace(/-----END PUBLIC KEY-----/, '')
            .replace(/\n/g, '');
        const binaryDerString = window.atob(keyData);
        const binaryDer = str2ab(binaryDerString);

        return window.crypto.subtle.importKey(
            'spki',
            binaryDer,
            {
                name: 'RSA-OAEP',
                hash: 'SHA-256',
            },
            true,
            ['encrypt']
        );
    }

    function str2ab(str) {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0; i < str.length; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    async function hybridEncryptFile(file, publicKeyPem) {
        try {
            // Step 1: Generate an AES key
            const aesKey = await generateAESKey();

            // Step 2: Encrypt the file with AES
            const { encryptedContent, iv } = await encryptFileWithAES(file, aesKey);

            // Step 3: Encrypt the AES key with RSA
            const encryptedAESKey = await encryptAESKeyWithRSA(aesKey, publicKeyPem);

            // Step 4: Package the encrypted file content, encrypted AES key, and IV
            const encryptedBlob = new Blob([encryptedContent], { type: file.type });

            return {
                encryptedFile: new File([encryptedBlob], `${file.name}.encrypted`, { type: file.type }),
                encryptedAESKey,
                iv
            };
        } catch (error) {
            console.error("Error during hybrid encryption:", error);
            throw error;
        }
    }

    const handleFileChange = async (event) => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles && uploadedFiles.length > 0) {
            setUploading(true);
            const file = uploadedFiles[0];

            let fileToUpload = file;
            let encryptedAESKey = null;
            let iv = null;

            if (encryptDecision) {
                try {
                    const { encryptedFile, encryptedAESKey: aesKey, iv: fileIv } = await hybridEncryptFile(file, publicKeyWorkspaceKey);
                    fileToUpload = encryptedFile;
                    encryptedAESKey = aesKey;
                    iv = fileIv;
                } catch (error) {
                    console.error("Error encrypting file:", error);
                    return;
                }
            }

            const fileType = file.name.split('.').pop();
            const formData = new FormData();
            formData.append('board', myBoard.id);
            formData.append('attachments', fileToUpload);
            formData.append('is_encrypted', encryptDecision);
            formData.append('file_type', fileType);

            if (encryptedAESKey && iv) {
                formData.append('encrypted_aes_key', new Blob([encryptedAESKey]));
                formData.append('iv', btoa(String.fromCharCode(...iv)));  // Include the IV in the form data
            }


            HandleUploadAttachment(workspace_id, myBoard.project, Task.id, formData, {
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(percentCompleted);
                }
            }).then((newAttachments) => {
                setUploadProgress(0);
                setUploading(false);
                setTask((prevTask) => ({
                    ...prevTask,
                    attachments: [...prevTask.attachments, ...newAttachments],
                }));

                setMyBoard(prevMyBoard => ({
                    ...prevMyBoard,
                    lists: prevMyBoard.lists.map(list => ({
                        ...list,
                        tasks: list.tasks.map(task =>
                            task?.id === Task.id
                                ? { ...task, has_attachments: true }
                                : task
                        )
                    }))
                }));

                setRefreshFlag(!refreshFlag);


            })
                .catch((error) => {
                    setUploadProgress(0);
                    setUploading(false);
                    console.error("Error uploading attachments:", error);
                    checkForWorkspaceStorageLimitError(error, t, showSnackbar);
                })

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    const handleEncryptFileModalClose = () => {
        setOpenEncryptFileModal(false);
    };

    const handleOpenDownloadWarning = (attachment, fileUrl) => {
        setSelectedAttachment(attachment);
        setSelectedFileUrl(fileUrl);
        setOpenDownloadWarningModal(true);
    };

    const handleProceedDownload = () => {
        setOpenDownloadWarningModal(false);
        handlePreviewImage(selectedAttachment, selectedFileUrl);
    };

    const handleCloseDownloadWarningModal = () => {
        setOpenDownloadWarningModal(false);
    };

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 900) {
                setActionsDropdownOpen(true);
            } else {
                setActionsDropdownOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleModal = () => {
        setOpenMobileAttachmentModal((prevOpen) => !prevOpen);
    };

    const handleCoverClick = () => {
        if (Task.cover_image) {
            setOpenCoverImageModal(true);
        }
    };

    const handleCloseCoverImageModal = () => {
        setOpenCoverImageModal(false);
    };

    const handlePaste = async (event) => {
        const clipboardItems = event.clipboardData.items;

        for (let item of clipboardItems) {
            if (item.type.startsWith("image")) {
                const file = item.getAsFile();
                setPastedImage(URL.createObjectURL(file));
                await saveNewCoverImage(file, Task.cover_color);
            }
        }
    };

    useEffect(() => {
        if (editingTaskTitle) {
            document.addEventListener("paste", handlePaste);
        } else {
            document.removeEventListener("paste", handlePaste);
        }

        return () => {
            document.removeEventListener("paste", handlePaste);
        };
    }, [editingTaskTitle]);

    useEffect(() => {
        if (autoFocusLabel) {
            setOpenLabels(true);
        }
        if (openCover) {
            setCoverModalOpen(true);
        }
    }, [autoFocusLabel, openCover]);

    useEffect(() => {
        const fetchTaskDetails = async () => {
            if (openViewTaskModal) {
                const response = await GetTaskInformation(workspace_id, myBoard.project, task_id);

                setTask((prevTask) => ({ ...prevTask, ...response.task }));
                setChecklists(response.checklists);
                setTaskActivityLog(response.top_activity_logs);
                setTaskComments(response.comments);
                setHasMoreComments(response.has_more_comments);
                setDescription(response.task.description);

                const fullLabels = response.task.label?.map(labelId =>
                    myBoard.labels.find(label => label.id === labelId)
                ).filter(label => label);

                setSelectedTaskLabels(fullLabels || []);

                const fullMembers = response.task.members?.map(memberId =>
                    workspaceWorkers.find(worker => worker.id === memberId)
                ).filter(worker => worker);

                setSelectedTaskMembers(fullMembers || []);


                setIsLoadingActivityLog(false);
            }
        };
        fetchTaskDetails();
    }, [openViewTaskModal]);

    const [newChecklistAdded, setNewChecklistAdded] = useState(false);

    const resetChecklistAdded = () => {
        setNewChecklistAdded(false);
    }

    const handleAddChecklist = async () => {
        try {
            const response = await CreateChecklist(workspace_id, myBoard.project, Task.id, t("modal.checklist_new"));

            const newChecklist = {
                ...response,
                checked_count: 0,
                total_count: 0,
            };

            setChecklists((prevChecklists) => [...prevChecklists, newChecklist]);
            setRefreshFlag(!refreshFlag);
            setNewChecklistAdded(true);
        } catch (error) {
            console.error("Error creating checklist:", error);
        }
    };

    const getRandomHex = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };
    const [labelColor, setLabelColor] = useState(getRandomHex());

    const myBoardSortedLabels = myBoard?.labels?.sort(
        (a, b) => a.order - b.order
    );

    const handleTitleClick = (title, event) => {
        const { clientX } = event;
        clickPositionRef.current = clientX;
        if (!editingTaskTitle) {
            setEditTaskNewTitle(title);
            setEditingTaskTitle(true);
        }
    };

    useEffect(() => {
        if (editingTaskTitle) {
            // Wait for the input to render
            setTimeout(() => {
                placeCaretAtClickPosition(editTaskNewTitle);
            }, 0);
        }
    }, [editingTaskTitle]);

    function extractLabelIds(labels) {
        return labels.map(label => label.id);
    }

    const inputRef = useRef(null);

    const placeCaretAtClickPosition = (title) => {
        const clickPosition = clickPositionRef.current;
        if (inputRef.current && clickPosition !== null) {
            const input = inputRef.current;
            const inputLeft = input.getBoundingClientRect().left;

            const tempSpan = document.createElement('span');
            tempSpan.style.visibility = 'hidden';
            tempSpan.style.position = 'absolute';
            tempSpan.style.whiteSpace = 'pre';

            const computedStyle = window.getComputedStyle(input);
            tempSpan.style.font = computedStyle.font;

            document.body.appendChild(tempSpan);

            let caretPosition = title.length;

            for (let i = 0; i < title.length; i++) {
                tempSpan.textContent = title.substring(0, i + 1);
                const width = tempSpan.getBoundingClientRect().width;

                if (width + inputLeft >= clickPosition) {
                    caretPosition = i;
                    break;
                }
            }

            document.body.removeChild(tempSpan);

            // Set the caret position
            input.setSelectionRange(caretPosition, caretPosition);
            input.focus();
        }
    };

    const handleTitleBlur = async () => {
        if (editTaskNewTitle === "") {
            setTaskTitleError(t("modal.task_empty"));
        } else {
            setTaskTitleError("");
            setEditingTaskTitle(false);

            await UpdateTask(workspace_id, myBoard.project, List, Task, editTaskNewTitle);
            setRefreshFlag(!refreshFlag);
            const updatedBoard = { ...myBoard };

            const listToUpdate = updatedBoard.lists.find(
                (list) => list.id === List.id
            );
            const taskToUpdate = listToUpdate.tasks.find(
                (task) => task?.id === Task.id
            );
            // Update the title of the task
            if (taskToUpdate) {
                setMyBoard((prevBoard) => {
                    const updatedBoard = { ...prevBoard };
                    const listToUpdate = updatedBoard.lists.find((list) => list.id === List.id);
                    if (listToUpdate) {
                        const taskToUpdate = listToUpdate.tasks.find((task) => task?.id === Task.id);
                        if (taskToUpdate) {
                            taskToUpdate.title = editTaskNewTitle;
                        }
                    }
                    return updatedBoard;
                });
                setMyBoard((prevBoard) => {
                    return {
                        ...prevBoard,
                        lists: prevBoard.lists.map((list) =>
                            list.id === List.id
                                ? {
                                    ...list,
                                    tasks: list.tasks.map((task) =>
                                        task?.id === Task.id ? { ...task, title: editTaskNewTitle } : task
                                    ),
                                }
                                : list
                        ),
                    };
                });
            }

            setEditingTaskTitle(null);
        }
    };

    const handleTitleChange = (event) => {
        event.target.value.toLowerCase();

        setTask((prevTask) => ({ ...prevTask, title: event.target.value }));
        setEditTaskNewTitle(event.target.value);
    };

    const handleAddLabel = () => {
        setOpenLabels(true);
    };

    const handleArchiveTaskModalOpen = () => {
        setOpenArchiveTaskModal(true);
    };

    const handleArchiveTaskModalClose = () => {
        setOpenArchiveTaskModal(false);
        handleTaskCloseMenu();
    };

    const handleTaskCloseMenu = () => {
        setContextTaskMenuPosition({ x: 0, y: 0 });
    };

    const handleAddNewLabel = async (title, color, close = true, description) => {
        const response = await AddLabelToBoard(workspace_id, myBoard.project, myBoard.id, title, color, description);

        if (response.status === 201) {
            const newLabel = { ...response.data, usage_count: 1 };

            setSelectedTaskLabels((prevLabels) => {
                prevLabels = prevLabels || [];
                const updatedLabels = [...prevLabels, newLabel];
                const updatedTask = { ...Task, label: extractLabelIds(updatedLabels) };
                setTask(updatedTask);
                setMyBoard((prevBoard) => ({
                    ...prevBoard,
                    lists: prevBoard.lists.map((list) =>
                        list.id === List.id
                            ? {
                                ...list,
                                tasks: list.tasks.map((task) =>
                                    task?.id === Task?.id ? updatedTask : task
                                ),
                            }
                            : list
                    ),
                }));

                return updatedLabels;
            });

            setMyBoard((prevBoard) => ({
                ...prevBoard,
                labels: [...prevBoard.labels, newLabel],
            }));
            showSnackbar(t("modal.label_added"), 'success');
        }

        if (close) {
            handleSetLabelAddClose();
        }
    };

    const saveNewCoverImage = async (image, color) => {
        const formData = new FormData();
        if (image) {
            formData.append("cover_image", image);
        } else {
            formData.append("cover_image", ""); // Explicitly indicate removal
        }

        if (color && color !== null) {
            formData.append("cover_color", color);
        }

        try {
            const response = await UpdateTaskCover(workspace_id, myBoard.project, Task.id, formData);

            if (response.status === 200 && response.data) {
                const { cover_color, cover_image } = response.data;

                // Update Task State
                setTask((prevTask) => ({
                    ...prevTask,
                    cover_color: cover_color || null,
                    cover_image: cover_image || null, // Explicitly handle removal
                }));

                // Update MyBoard State
                setMyBoard((prevBoard) => {
                    const updatedLists = prevBoard.lists.map((list) => {
                        if (list.id === List.id) {
                            const updatedTasks = list.tasks.map((task) =>
                                task?.id === Task.id
                                    ? {
                                        ...task,
                                        cover_color: cover_color || null,
                                        cover_image: cover_image || null
                                    }
                                    : task
                            );
                            return { ...list, tasks: updatedTasks };
                        }
                        return list;
                    });
                    return { ...prevBoard, lists: updatedLists };
                });

                showSnackbar(t("modal.cover_updated"), "success");
            } else {
                showSnackbar(t("modal.cover_update_failed"), "error");
            }
        } catch (error) {
            console.error("Error saving cover image:", error);
            showSnackbar(t("modal.cover_update_failed"), "error");
        }
    };

    const handleEditLabel = async (title, color, label_id, description) => {
        const response = await UpdateLabel(workspace_id, myBoard.project, label_id, title, color, description);

        if (response.status === 200) {
            setSelectedTaskLabels((prevLabels) => {
                const initializedLabels = prevLabels || [];
                const indexToUpdate = initializedLabels.findIndex(label => label.id === label_id);

                if (indexToUpdate !== -1) {

                    const updatedLabels = [
                        ...initializedLabels.slice(0, indexToUpdate),
                        response.data,
                        ...initializedLabels.slice(indexToUpdate + 1)
                    ];
                    setTask((prevTask) => ({
                        ...prevTask,
                        label: extractLabelIds(updatedLabels),
                    }));
                    return updatedLabels;
                }
                return initializedLabels;
            });

            setMyBoard((prevBoard) => {

                const updatedLabels = (prevBoard.labels || []).map(label =>
                    label.id === label_id ? response.data : label
                );

                const updatedLists = (prevBoard.lists || []).map(list => ({
                    ...list,
                    tasks: (list.tasks || []).map(task => ({
                        ...task,
                        label: Array.isArray(task?.label)
                            ? task?.label.map(label =>
                                label.id === label_id ? response.data : label
                            )
                            : []
                    }))
                }));

                return {
                    ...prevBoard,
                    labels: updatedLabels,
                    lists: updatedLists
                };
            });


        }
        setLabelEditing(false);
    };

    const handleClose = () => {
        handleSaveLabel(false);
        if (labelAdding) {
            setLabelAdding(false);
            return;
        }

        if (labelEditing) {
            setLabelEditing(false);
            setLabelToEdit(null)
            return;
        }

        if (autoFocusLabel) {
            handleViewTaskModalClose()
        }
        setOpenLabels(false);
    };

    const handleSetLabelAddOpen = () => {
        setLabelColor(getRandomHex());
        setLabelTitle("");
        setLabelAdding(true);
    };

    const handleSetLabelAddClose = () => {
        handleAddLabel(labelTitle, labelColor);
        setLabelAdding(false);
    };

    const handleSetCancelEdit = () => {
        setLabelEditing(false);
    };

    const toggleLabelSelection = (label) => {
        setSelectedTaskLabels((prevLabels) => {
            const labelIndex = prevLabels.findIndex((item) => item.id === label.id);
            const isRemovingLabel = labelIndex !== -1; //-1 is when its getting removed

            const updatedLabels = isRemovingLabel
                ? prevLabels.filter((item) => item.id !== label.id)
                : [...prevLabels, label];

            setTask((prevTask) => ({
                ...prevTask,
                label: extractLabelIds(updatedLabels),
            }));

            setMyBoard((prevBoard) => {
                const updatedBoardLabels = prevBoard.labels.map((boardLabel) => {
                    if (boardLabel.id === label.id) {
                        return {
                            ...boardLabel,
                            usage_count: isRemovingLabel
                                ? Math.max(0, boardLabel.usage_count - 1) // Prevent negative counts somehow
                                : boardLabel.usage_count + 1,
                        };
                    }
                    return boardLabel;
                });

                return {
                    ...prevBoard,
                    labels: updatedBoardLabels,
                };
            });

            return updatedLabels;
        });
    };

    const handleSaveLabel = (close = true) => {
        SaveTaskLabels(workspace_id, myBoard.project, Task.id, selectedTaskLabels);

        const updatedBoard = {
            ...myBoard,
            lists: myBoard.lists.map((list) => ({
                ...list,
                tasks: list.tasks.map((task) => {
                    if (task?.id === Task.id) {
                        return {
                            ...task,
                            label: Task.label
                        };
                    }
                    return task;
                }),
            })),
        };

        setMyBoard(updatedBoard);
        if (close) {
            setOpenLabels(false);
        }

        setLabelTitle("");
        setLabelColor(getRandomHex());
    };

    const [openDeleteLabelModal, setOpenDeleteLabelModal] = useState(false);
    const [labelIdToDelete, setLabelIdToDelete] = useState(null);

    const DeleteLabelModalOpen = (label_id) => {
        setLabelIdToDelete(label_id)
        setOpenDeleteLabelModal(true);
    };

    const DeleteLabelModalClose = () => {
        setLabelIdToDelete(null)
        setOpenDeleteLabelModal(false);
    };

    const handleDeleteLabel = async (label_id) => {
        try {
            await DeleteLabel(workspace_id, myBoard.project, myBoard.id, label_id);

            setMyBoard((prevBoard) => ({
                ...prevBoard,
                labels: prevBoard.labels.filter((label) => label.id !== label_id),
            }));

            setTask((prevTask) => {
                const updatedLabels = prevTask.label.filter((id) => id !== label_id);
                return {
                    ...prevTask,
                    label: updatedLabels,
                };
            });

            setSelectedTaskLabels((prevLabels) =>
                prevLabels.filter((item) => item.id !== label_id)
            );

            DeleteLabelModalClose();
        } catch (error) {
            console.error("Error deleting label:", error);
        }
    };

    const handleEditClick = (label) => {
        setLabelToEdit(label)
        setLabelEditing(true);
    };

    const handleTaskDatesDialogOpen = () => {
        setTaskDatesDialogOpen(true);

    }

    const handleTaskDatesDialogClose = () => {
        setTaskDatesDialogOpen(false);
    };

    const handleTaskMembersDialogOpen = async () => {
        const projectWorkersData = await getProjectWorkers(workspace_id, myBoard.project);
        const projectWorkerIDs = projectWorkersData.map(worker => worker.id);
        const workersFromWorkspace = workspaceWorkers.filter(worker =>
            projectWorkerIDs.includes(worker.id)
        );
        const updatedFilteredWorkers = workersFromWorkspace.filter(worker =>
            worker.full_name.toLowerCase().includes(searchQuery.toLowerCase())
        );

        setFilteredProjectWorkers(updatedFilteredWorkers);
        setTaskMembersDialogOpen(true);
    };


    const handleTaskMembersDialogClose = () => {
        setTaskMembersDialogOpen(false);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleMemberSelection = (worker) => {
        setSelectedTaskMembers((prevSelectedMembers) => {
            if (prevSelectedMembers.some((member) => member.id === worker.id)) {
                return prevSelectedMembers.filter((member) => member.id !== worker.id);
            } else {
                return [...prevSelectedMembers, worker];
            }
        });
    };

    const handleSaveMembers = async () => {
        try {
            const notify_user = (List.title === "Done") ? false : true;
            await updateTaskMembers(workspace_id, myBoard.project, Task.id, selectedTaskMembers, notify_user);

            const memberIds = selectedTaskMembers.map(member => member.id);


            const updatedBoard = {
                ...myBoard,
                lists: myBoard.lists.map((list) => ({
                    ...list,
                    tasks: list.tasks.map((task) => {
                        if (task?.id === Task.id) {
                            return {
                                ...task,
                                members: memberIds,
                            };
                        }
                        return task;
                    }),
                })),
            };

            setMyBoard(updatedBoard);
            setTaskMembersDialogOpen(false);
        } catch (error) {
            console.error("Error updating task members:", error);
        } finally {
            setRefreshFlag(!refreshFlag);
        }
    };

    const handleSaveDates = async (dates) => {
        try {
            const response = await UpdateTaskDates(workspace_id, myBoard.project, Task.id, dates);
            if (response.status === 200) {
                let updatedTask = response.data;
                Task.start_date = dates.start_date;
                Task.due_date = dates.due_date;
                Task.end_date = dates.end_date;
                updatedTask.start_date = dates.start_date;
                updatedTask.due_date = dates.due_date;
                updatedTask.end_date = dates.end_date;

                setMyBoard((prevBoard) => {
                    return {
                        ...prevBoard,
                        lists: prevBoard.lists.map((list) => ({
                            ...list,
                            tasks: list.tasks.map((task) =>
                                task?.id === Task.id ? { ...task, ...updatedTask } : task
                            ),
                        })),
                    };
                });
            }

            setRefreshFlag(!refreshFlag);
            setTaskDatesDialogOpen(false);
        } catch (error) {
            console.error("Error updating task dates:", error);
        }
    };

    const handleDescription = async (json) => {
        try {
            setDescription(json);

            let data;
            try {
                data = JSON.parse(json);
            } catch (error) {
                data = null;
            }
            const hasDescription = data && (
                data.entityMap && Object.keys(data.entityMap).length > 0 ||
                data.blocks.some(block => block.text !== "")
            );
            const updatedBoard = { ...myBoard };
            updatedBoard.lists = updatedBoard.lists.map((list) => {
                return {
                    ...list,
                    tasks: list.tasks.map((task) => {
                        if (task?.id === Task.id) {
                            return { ...task, has_description: hasDescription };
                        }
                        return task;
                    }),
                };
            });

            setMyBoard(updatedBoard);

            await UpdateTaskDescription(workspace_id, myBoard.project, Task.id, json);

            setRefreshFlag((prev) => !prev);
        } catch (error) {
            checkForWorkspaceStorageLimitError(error, t, showSnackbar);
        }
    };

    const updateChecklistCompletion = ({ total, completed }) => {
        const updatedBoard = { ...myBoard };
        updatedBoard.lists = updatedBoard.lists.map((list) => ({
            ...list,
            tasks: list.tasks.map((task) =>

                task?.id === Task.id
                    ? {
                        ...task,
                        checklist_completion: { total, completed },
                    }
                    : task
            ),
        }));

        setMyBoard(updatedBoard);
    };

    const [prevTotals, setPrevTotals] = useState({ total: 0, completed: 0 });

    useEffect(() => {
        const total = checklists.reduce((sum, cl) => sum + cl.total_count, 0);
        const completed = checklists.reduce(
            (sum, cl) => sum + cl.items.filter((item) => item.checked).length,
            0
        );

        // Only update if changes occurred
        if (total !== prevTotals.total || completed !== prevTotals.completed) {
            updateChecklistCompletion({ total, completed });
            setPrevTotals({ total, completed });
        }
    }, [checklists, prevTotals, updateChecklistCompletion]);

    useEffect(() => {
        const keyframesStyle = `
            @keyframes rainbow {
                0% { background-position: 0% 50%; }
                50% { background-position: 100% 50%; }
                100% { background-position: 0% 50%; }
            }
        `;

        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = keyframesStyle;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, []);

    const handleCloseViewTask = () => {
        setTask([]);
        setDescription(null);
        setTaskActivityLog(null);
        handleViewTaskModalClose();
    };

    const [selectedPreviewImage, setSelectedPreviewImage] = useState(null);
    const [openImagePreviewModal, setOpenImagePreviewModal] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const handleCloseImageModal = () => {
        setOpenImagePreviewModal(false);
        setSelectedPreviewImage(null);
    };

    const handleDeleteAttachment = (attachment, event) => {
        event.stopPropagation();
        setSelectedAttachment(attachment);
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setSelectedAttachment(null);
    };

    const handlePreviewImage = async (attachment, fileUrl) => {
        const originalFilename = `${attachment.filename}.${attachment.file_extension}`;

        try {
            const response = await downloadEncryptedFile(workspace_id, attachment.id);
            const decryptedFileUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = decryptedFileUrl;
            link.download = originalFilename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            window.open(`${process.env.REACT_APP_BACKEND_URL}/temp-file/file-error-downloading-404-not-found/`, '_blank');
            console.error('Errorsz fetching and decrypting file:', error);
        }

    };

    const handleCoverTouch = (cover_img) => {
        window.open(cover_img, '_blank');
    };

    const handleImageTouch = () => {
        const fileUrl = selectedPreviewImage;
        window.open(fileUrl, '_blank');
    };

    const handleConfirmDelete = async (deleteFromStorage) => {
        try {
            await DeleteTaskAttachment(workspace_id, myBoard.project, Task.id, selectedAttachment.id, deleteFromStorage);

            setTask((prevTask) => ({
                ...prevTask,
                attachments: prevTask.attachments.filter((att) => att.id !== selectedAttachment.id),
            }));

            handleCloseDeleteDialog();
        } catch (error) {
            console.error("Error deleting attachment:", error);
        }
    };

    const getLabelUsageCount = (labelId) => {
        const label = myBoard.labels.find((label) => label.id === labelId);
        return label?.usage_count || 0;
    };

    const updateCommentsState = (state) => {
        const updatedBoard = { ...myBoard };

        updatedBoard.lists = updatedBoard.lists.map((list) => {
            return {
                ...list,
                tasks: list.tasks.map((task) => {
                    if (task?.id === Task.id) {
                        return { ...task, has_comments: state };
                    }
                    return task;
                }),
            };
        });

        setMyBoard(updatedBoard);
    };

    const clickPositionRef = useRef(null);

    const handleMarkAsDoingMobileMenu = (task_id, pos, list_id) => {
        handleMarkAsDoing(task_id, pos, list_id)
        handleCloseMenu();
    };

    const handleMarkAsDoneMobileMenu = (task_id, list_id) => {
        handleMarkAsDone(task_id, list_id)
        handleCloseMenu();
    };

    return (
        <>
            {openArchiveTaskModal && (
                <ArchiveTaskModal myTask={Task} myBoardLabels={myBoard.labels} getColorForTask={getColorForTask}
                    openArchiveTaskModal={openArchiveTaskModal} formatDate={formatDate} workspaceWorkers={workspaceWorkers} handleArchiveTaskModalClose={handleArchiveTaskModalClose}
                    handleArchiveTask={handleArchiveTask} avoidMisfire={avoidMisfire} />
            )}
            <DeleteLabelModal
                openDeleteLabelModal={openDeleteLabelModal}
                DeleteLabelModalClose={DeleteLabelModalClose}
                handleDeleteLabel={handleDeleteLabel}
                avoidMisfire={avoidMisfire}
                labelIdToDelete={labelIdToDelete}
            />

            <Dialog
                open={openViewTaskModal}
                onClose={handleCloseViewTask}
                className="modal-background-color view-task-dialog"
            >
                <Box className="view-task-scrollable-content" ref={contentRef}>
                    <Box
                        className={`view-task-cover 
                            ${Task.cover_image || Task.cover_color ? 'has-cover' : 'no-cover'}
                            ${hasScroll ? 'has-scroll' : ''}`}
                        onClick={() => {
                            if (Task.cover_image) {
                                handleCoverClick(); // Open the image if it exists
                            } else {
                                setCoverModalOpen(true); // Open the modal if no image exists
                            }
                        }}
                        style={{
                            background: Task.cover_image
                                ? `url(${Task.cover_image}), ${Task.cover_color || '#545454'}`
                                : Task.cover_color || '#545454',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            position: 'relative',
                        }}
                    >
                        {(!Task.cover_image && !Task.cover_color) && (
                            <Button
                                className="add-cover-button"
                                startIcon={<AddIcon />}
                            >
                                {t("project_page.add_cover")}

                            </Button>
                        )}

                        {(Task.cover_image || Task.cover_color) && (
                            <IconButton
                                className="cover-edit-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setCoverModalOpen(true);
                                }}
                            >
                                <EditIcon />
                            </IconButton>
                        )}
                    </Box>


                    <DialogTitle
                        className="view-task-dialog-title"
                    >

                        <Box
                            onDoubleClick={(e) => handleTitleClick(Task.title, e)}
                            className="view-task-title-box"
                        >
                            <div>
                                {editingTaskTitle ? (
                                    <Box display="flex" alignItems="center">
                                        <b>#{Task.frontend_order} - </b>
                                        <TextField
                                            className="view-task-width"
                                            value={editTaskNewTitle}
                                            onChange={handleTitleChange}
                                            onBlur={handleTitleBlur}
                                            autoFocus
                                            InputProps={{
                                                className: "view-task-label-title-input",
                                                inputRef: inputRef,
                                                disableUnderline: false,
                                            }}
                                            multiline
                                            variant="standard"
                                            sx={{
                                                flex: 1,
                                                '& .MuiInputBase-root': {
                                                    fontSize: 'inherit',
                                                },
                                            }}
                                        />
                                    </Box>

                                ) : (
                                    <ScrollAwareTooltip title={t("project_page.double_click")} placement="top-start">
                                        <span
                                            className="view-task-edit-title"
                                        >
                                            <b>#{Task.frontend_order}</b> - {Task.title}
                                        </span>
                                    </ScrollAwareTooltip>
                                )}

                                <Typography
                                    className="view-task-list-error"
                                >
                                    {taskTitleError}
                                </Typography>
                            </div>
                        </Box>
                        <Box className="view-task-box-container">
                            <Typography className="view-task-in-list">
                                {t("modal.in_list")} {List.title}
                            </Typography>
                            {Task.start_date ? (
                                <ScrollAwareTooltip title={t("global.start_date")}>
                                    <Box className="view-task-date-box view-task-start-date" onClick={() => handleTaskDatesDialogOpen()}>
                                        <Typography variant="body2" sx={{ color: "#91c6fd" }}>
                                            {formatDateToStringHHMM(ConvertToMyTimeZone(Task.start_date, myUserTimezone.timezone))}
                                        </Typography>
                                    </Box>
                                </ScrollAwareTooltip>
                            ) : (
                                <ScrollAwareTooltip title={t("global.start_date")}>
                                    <Box className="view-task-date-box view-task-start-date" onClick={() => handleTaskDatesDialogOpen()}>
                                        <Typography variant="body2" sx={{ color: "#91c6fd" }}>
                                            {t("core.no_start_date")}
                                        </Typography>
                                    </Box>
                                </ScrollAwareTooltip>
                            )}

                            {Task.due_date ? (
                                <ScrollAwareTooltip title={t("core.due_date")}>
                                    <Box className="view-task-date-box view-task-due-date" onClick={() => handleTaskDatesDialogOpen()}>
                                        <Typography variant="body2" sx={{ color: "#1D2125" }}>
                                            {formatDateToStringHHMM(ConvertToMyTimeZone(Task.due_date, myUserTimezone.timezone))}
                                        </Typography>
                                    </Box>
                                </ScrollAwareTooltip>
                            ) : (
                                <ScrollAwareTooltip title={t("core.due_date")}>
                                    <Box className="view-task-date-box view-task-due-date" onClick={() => handleTaskDatesDialogOpen()}>
                                        <Typography variant="body2" sx={{ color: "#1D2125" }}>
                                            {t("core.no_due_date")}
                                        </Typography>
                                    </Box>
                                </ScrollAwareTooltip>
                            )}

                            {Task.end_date ? (
                                <ScrollAwareTooltip title={t("core.end_date")}>
                                    <Box className="view-task-date-box view-task-end-date" onClick={() => handleTaskDatesDialogOpen()}>
                                        <Typography variant="body2" sx={{ color: "#1D2125" }}>
                                            {formatDateToStringHHMM(ConvertToMyTimeZone(Task.end_date, myUserTimezone.timezone))}
                                        </Typography>
                                    </Box>
                                </ScrollAwareTooltip>
                            ) : (
                                <ScrollAwareTooltip title={t("core.end_date")}>
                                    <Box className="view-task-date-box view-task-end-date" onClick={() => handleTaskDatesDialogOpen()}>
                                        <Typography variant="body2" sx={{ color: "#1D2125" }}>
                                            {t("core.no_end_date")}
                                        </Typography>
                                    </Box>
                                </ScrollAwareTooltip>
                            )}
                        </Box>

                        <div className={`view-task-buttons ${editingTaskTitle ? 'hide' : 'show'}`}>

                            <div className="view-task-dropdown-button" onClick={toggleModal}>
                                <FileOpenIcon />
                            </div>

                            <div className="view-task-dropdown-button" onClick={handleOpenMenu}>
                                <MenuIcon />
                            </div>

                        </div>

                        <AttachmentsModal
                            openModal={openMobileAttachmentModal}
                            toggleModal={toggleModal}
                            Task={Task}
                            t={t}
                            handleFileChange={handleFileChange}
                            handleDeleteAttachment={handleDeleteAttachment}
                            handlePreviewImage={handlePreviewImage}
                            setOpenEncryptFileModal={setOpenEncryptFileModal}
                            handleOpenDownloadWarning={handleOpenDownloadWarning}
                        />

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            PaperProps={{
                                className: "view-task-menu-actions"
                            }}
                        >
                            <MenuItem disableRipple>
                                <Box
                                    className="view-task-menu-item"
                                >
                                    {t("global.actions")}
                                </Box>
                            </MenuItem>
                            <Divider className="view-task-menu-divider" key="divider" />


                            <MenuItem
                                onClick={handleTaskMembersDialogOpen}
                            >
                                {t("modal.members")}
                            </MenuItem>


                            {List.title !== "Doing" && (
                                <MenuItem
                                    onClick={() => handleMarkAsDoingMobileMenu(Task.id, 0, List.id)}
                                >
                                    {t("project_page.mark_doing")}
                                </MenuItem>
                            )}
                            {List.title !== "Done" && (
                                <MenuItem
                                    onClick={() => handleMarkAsDoneMobileMenu(Task.id, List.id)}
                                >
                                    {t("project_page.mark_done")}
                                </MenuItem>
                            )}
                            <MenuItem
                                onClick={handleArchiveTaskModalOpen}
                            >
                                {t("modal.archive")}
                            </MenuItem>
                        </Menu>
                    </DialogTitle>

                    <DialogContent className="view-task-full-width">
                        <Grid container spacing={2}>
                            <Grid item md={9} xs={12}>
                                <Box
                                    className="view-task-content-box"
                                >
                                    <div className="view-task-content-div">
                                        <div className="view-task-label-add">
                                            <Typography className="view-task-label-margin">
                                                {t("modal.labels")}
                                            </Typography>
                                            <AddIcon
                                                className="view-task-add-label-icon"
                                                onClick={handleAddLabel}
                                            />
                                        </div>

                                        <div className="view-task-flex">
                                            {selectedTaskLabels?.map((label) => {
                                                return (
                                                    <div
                                                        key={label.id}
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            updateToggleLabel();
                                                        }}
                                                        style={{ backgroundColor: label.color }}
                                                        className={`view-task-label-style ${label.color === "rainbow" ? 'rainbow' : ''}`}
                                                    >

                                                        <ScrollAwareTooltip title={
                                                            <>
                                                                {label.description || t("modal.label_no_desc")}
                                                                <br />
                                                                {t("modal.label_task_number", { var1: getLabelUsageCount(label.id), var2: getLabelUsageCount(label.id) === 1 ? '' : 's' })}
                                                            </>
                                                        } placement="top">

                                                            <Typography
                                                                className={`view-task-label-title ${label.color === "rainbow" ? 'no-shadow' : 'with-shadow'}`}
                                                                style={{ color: getTextColor(label.color) }}
                                                            >
                                                                {label.title}
                                                            </Typography>
                                                        </ScrollAwareTooltip>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <LabelsComponent
                                        open={openLabels}
                                        t={t}
                                        labelAdding={labelAdding}
                                        myBoardSortedLabels={myBoardSortedLabels}
                                        selectedTaskLabels={selectedTaskLabels}
                                        toggleLabelSelection={toggleLabelSelection}
                                        handleEditClick={handleEditClick}
                                        DeleteLabelModalOpen={DeleteLabelModalOpen}
                                        handleSetLabelAddOpen={handleSetLabelAddOpen}
                                        handleSetLabelAddClose={handleSetLabelAddClose}
                                        handleSaveLabel={handleSaveLabel}
                                        handleSetCancelEdit={handleSetCancelEdit}
                                        handleAddNewLabel={handleAddNewLabel}
                                        handleEditLabel={handleEditLabel}
                                        handleClose={handleClose}
                                        labelToEdit={labelToEdit}
                                        labelEditing={labelEditing}
                                        handleEditingClose={handleClose}
                                        setAutoFocusLabel={setAutoFocusLabel}
                                    />
                                </Box>

                                <Typography className="view-task-description-margin" variant="h6">{t("modal.description")}</Typography>

                                <div
                                    className="view-task-description-text-div"
                                >
                                    <TextEditor
                                        handleDescription={handleDescription}
                                        value={description}
                                    />
                                </div>

                                <ChecklistComponent
                                    Task={Task}
                                    handleAddChecklist={handleAddChecklist}
                                    handleSaveTask={handleSaveTask}
                                    List_id={List.id}
                                    checklists={checklists}
                                    setChecklists={setChecklists}
                                    editChecklistTitles={editChecklistTitles}
                                    setEditChecklistTitles={setEditChecklistTitles}
                                    newChecklistTitles={newChecklistTitles}
                                    setNewChecklistTitles={setNewChecklistTitles}
                                    setContextTaskMenuPosition={setContextTaskMenuPosition}
                                    UpdateChecklistOrder={UpdateChecklistOrder}
                                    UpdateChecklistItem={UpdateChecklistItem}
                                    UpdateChecklistTitle={UpdateChecklistTitle}
                                    DeleteChecklistItem={DeleteChecklistItem}
                                    GetChecklists={GetChecklists}
                                    DeleteChecklist={DeleteChecklist}
                                    CreateChecklistItem={CreateChecklistItem}
                                    avoidMisfire={avoidMisfire}
                                    setRefreshFlag={setRefreshFlag}
                                    refreshFlag={refreshFlag}
                                    workspace_id={workspace_id}
                                    project_id={myBoard.project}
                                    ToggleHiddenStatusOfChecklists={ToggleHiddenStatusOfChecklists}
                                    ToggleHiddenStatusOfChecklistItems={ToggleHiddenStatusOfChecklistItems}
                                    newChecklistAdded={newChecklistAdded}
                                    ConvertToTask={ConvertToTask}
                                    getMoreChecklistItems={getMoreChecklistItems}
                                    updateChecklistCompletion={updateChecklistCompletion}
                                    resetChecklistAdded={resetChecklistAdded}
                                />

                                <Comments task_id={Task.id} project_id={myBoard.project} myUserTimezone={myUserTimezone.timezone} taskComments={taskComments} hasMoreComments={hasMoreComments} setHasMoreComments={setHasMoreComments} updateCommentsState={updateCommentsState} />

                                <ActivityLog
                                    taskActivityLog={taskActivityLog}
                                    myUserTimezone={myUserTimezone}
                                    showAllActivity={showAllActivity}
                                    toggleShowAllActivity={toggleShowAllActivity}
                                    isLoadingActivityLog={isLoadingActivityLog}
                                    fetchAllActivityLogs={fetchAllActivityLogs}
                                    t={t}
                                />


                            </Grid>
                            <Grid item xs={3} className={`view-task-actions-border ${actionsDropdownOpen ? 'show' : 'hide'}`}>
                                {" "}
                                {/* Actions box takes 20% of the width */}
                                <Box
                                    className="view-task-actions"
                                >
                                    <Typography className="view-task-actions-title">
                                        {t("modal.members")}
                                    </Typography>

                                    <Box sx={{ display: "flex" }}>
                                        <CommonAvatarGroup users={selectedTaskMembers} handleAvatarGroupClick={handleTaskMembersDialogOpen} myLoggedUser={getCurrentlyLoggedUser} />
                                        <Button onClick={handleTaskMembersDialogOpen}>
                                            <GroupAddIcon className="view-add-member-button" />
                                        </Button>
                                    </Box>

                                    <Typography className="view-task-actions-title">
                                        {t("global.actions")}
                                    </Typography>

                                    <Dialog
                                        open={taskMembersDialogOpen}
                                        onClose={handleTaskMembersDialogClose}
                                        className="view-task-label-dialog"
                                    >
                                        <DialogTitle className="view-task-label-title-width">
                                            {t("modal.select_members")}
                                        </DialogTitle>
                                        <DialogContent>
                                            <Typography variant="subtitle2">{t("modal.project_workers")}</Typography>
                                            <TextField
                                                placeholder={t("modal.search_workers")}
                                                onChange={handleSearchChange}
                                                variant="outlined"
                                                className="view-task-search-workers"
                                            />
                                            <div>
                                                {filteredProjectWorkers?.map((worker) => (
                                                    <div
                                                        key={worker.id}
                                                        className="view-task-workers-list"
                                                    >
                                                        <Checkbox
                                                            checked={selectedTaskMembers?.some(
                                                                (member) => member.id === worker.id
                                                            )}
                                                            onChange={() => toggleMemberSelection(worker)}
                                                            color="primary"
                                                        />
                                                        <div
                                                            onClick={() => toggleMemberSelection(worker)}
                                                            className={`view-task-member-list ${selectedTaskMembers?.some(member => member.id === worker.id) ? 'selected' : ''}`}
                                                        >
                                                            <Avatar
                                                                alt={worker.username}
                                                                src={worker.image}
                                                            />
                                                            <Typography
                                                                variant="body2"
                                                                className="view-task-worker-name"
                                                            >
                                                                {worker.full_name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button className="decline-button" onClick={handleTaskMembersDialogClose}><CancelIcon style={{ marginRight: 4 }} /> {t("global.cancel")}</Button>
                                            <Button className="accept-button" onClick={() => handleSaveMembers()} ><CheckCircleIcon style={{ marginRight: 4 }} />{t("global.save")}</Button>
                                        </DialogActions>
                                    </Dialog>

                                    <TaskDatesDialog
                                        open={taskDatesDialogOpen}
                                        onClose={handleTaskDatesDialogClose}
                                        task={Task}
                                        handleSaveDates={handleSaveDates}
                                        myUserTimezone={myUserTimezone.timezone}
                                    />

                                    {List.title !== "Doing" && (
                                        <Button
                                            onClick={() => handleMarkAsDoing(Task.id, 0, List.id)}
                                            className="view-task-actions-button"
                                        >
                                            {t("project_page.mark_doing")}
                                        </Button>
                                    )}
                                    {List.title !== "Done" && (
                                        <Button
                                            onClick={() => handleMarkAsDone(Task.id, List.id)}
                                            className="view-task-actions-button"
                                        >
                                            {t("project_page.mark_done")}
                                        </Button>
                                    )}
                                    <Button
                                        onClick={() => handleArchiveTaskModalOpen()}
                                        className="view-task-actions-button"
                                    >
                                        {t("modal.archive")}
                                    </Button>


                                    <Typography className="view-task-actions-title">
                                        {t("modal.attachments")}
                                    </Typography>

                                    {/* Transparent button to upload new attachments */}
                                    {uploading ? (
                                        <Box sx={{ width: '100%', mt: 1, mb: 2 }}>
                                            <LinearProgress
                                                variant="determinate"
                                                value={uploadProgress}
                                                sx={{
                                                    height: 8,
                                                    borderRadius: 4,
                                                    '& .MuiLinearProgress-bar': {
                                                        borderRadius: 4,
                                                    }
                                                }}
                                            />
                                        </Box>
                                    ) : (
                                        <Button
                                            variant="text"
                                            component="span"
                                            className="view-task-upload-button"
                                            onClick={() => setOpenEncryptFileModal(true)}
                                        >
                                            <UploadFileIcon className="view-task-attachments-icon" />
                                            {t("modal.upload_attachment")}
                                        </Button>
                                    )}
                                    <input
                                        accept="*"
                                        id="upload-button-file"
                                        multiple
                                        type="file"
                                        ref={fileInputRef}
                                        className="no-display"
                                        onChange={handleFileChange}
                                    />


                                    {/* List existing attachments */}
                                    <Box className="view-task-attachments-list">
                                        {Task.attachments && Task.attachments.length > 0 && (
                                            Task.attachments.map((attachment, index) => {
                                                const fileUrl = `${attachment.file}`;
                                                let AttachmentIcon;
                                                if (attachment.file_type === 'Image') {
                                                    AttachmentIcon = <ImageIcon className="view-task-attachments-icon" />;
                                                } else if (attachment.file_type === 'Document') {
                                                    AttachmentIcon = <InsertDriveFileIcon className="view-task-attachments-icon" />;
                                                } else if (attachment.file_type === 'Archive') {
                                                    AttachmentIcon = <ArchiveIcon className="view-task-attachments-icon" />;
                                                } else {
                                                    AttachmentIcon = <InsertDriveFileIcon className="view-task-attachments-icon" />;
                                                }

                                                return (
                                                    <Box
                                                        key={index}
                                                        className="view-task-image-preview"
                                                        onClick={() => handleOpenDownloadWarning(attachment, fileUrl)}
                                                    >
                                                        {AttachmentIcon}
                                                        <Box className="view-task-attachment-box">
                                                            <Typography className="view-task-attachment-name">{attachment.filename}</Typography>
                                                            <Typography variant="body2" color="rgba(255, 255, 255, 0.6)">
                                                                {t(`file_types.${attachment.file_type}`)}
                                                                {attachment.file_type === "Encrypted File" && (
                                                                    <LockIcon sx={{ color: "lightblue", fontSize: "medium", marginLeft: "2px" }} />
                                                                )}
                                                            </Typography>
                                                        </Box>
                                                        <IconButton
                                                            className="view-task-attachment-delete-icon"
                                                            onClick={(event) => handleDeleteAttachment(attachment, event)}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Box>
                                                );
                                            })
                                        )}

                                        {/* Image preview modal */}
                                        <Dialog open={openImagePreviewModal} onClose={handleCloseImageModal} >
                                            <DialogContent className="view-task-image-preview-modal">
                                                <IconButton
                                                    onClick={handleCloseImageModal}
                                                    className="view-task-image-preview-close-icon"
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                                {selectedPreviewImage && (
                                                    <div onClick={handleImageTouch} className="view-task-attachment-image-div">
                                                        <img
                                                            src={selectedPreviewImage}
                                                            alt="Preview"
                                                            className="view-task-attachment-image-preview"
                                                        />
                                                    </div>
                                                )}
                                            </DialogContent>
                                        </Dialog>

                                        {/* Delete confirmation dialog */}
                                        <Dialog
                                            open={openDeleteDialog}
                                            onClose={handleCloseDeleteDialog}
                                            className="modal-background-color"
                                        >
                                            <DialogTitle className="view-task-delete-attachment-title">{t("modal.delete_attachment_title")}</DialogTitle>
                                            <DialogContent>
                                                <Typography>
                                                    {t("modal.delete_attachment", { var1: selectedAttachment?.filename })}
                                                </Typography>
                                            </DialogContent>
                                            <DialogActions className="dialog-delete-attach-flex">
                                                <Button
                                                    onClick={() => handleConfirmDelete(false)}
                                                    className="decline-button decline-button-viewtask-attach"
                                                >
                                                    <CancelIcon style={{ marginRight: 4 }} />
                                                    {t("modal.delete_from_task")}
                                                </Button>
                                                <Button
                                                    onClick={() => handleConfirmDelete(true)}
                                                    className="decline-button decline-button-viewtask-attach"
                                                >
                                                    <LayersClearIcon style={{ marginRight: 4 }} />
                                                    {t("modal.delete_from_all")}
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Box>

                                    <CoverPickerModal
                                        open={openCover}
                                        setCoverModalOpen={setCoverModalOpen}
                                        saveNewCoverImage={saveNewCoverImage}
                                        cover_color={Task.cover_color}
                                        cover_image={Task.cover_image}
                                    />

                                    <DownloadWarningModal
                                        openDownloadWarningModal={openDownloadWarningModal}
                                        handleCloseDownloadWarningModal={handleCloseDownloadWarningModal}
                                        handleProceedDownload={handleProceedDownload}
                                        avoidMisfire={false}
                                    />

                                    <EncryptFileModal
                                        openEncryptFileModal={openEncryptFileModal}
                                        handleEncryptFileModalClose={handleEncryptFileModalClose}
                                        handleFileEncryption={handleFileEncryption}
                                        avoidMisfire={false}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Box>
            </Dialog>
            <Dialog
                open={openCoverImageModal}
                onClose={handleCloseCoverImageModal}
            >
                <DialogContent className="view-task-image-preview-modal">
                    {Task.cover_image && (
                        <div className="view-task-attachment-image-div">
                            <img
                                src={Task.cover_image}
                                alt="Cover Preview"
                                className="view-task-cover-image-preview"
                                onClick={() => handleCoverTouch(Task.cover_image)}
                            />
                        </div>
                    )}
                </DialogContent>

            </Dialog>

        </>
    );
}
